/* eslint-disable react/no-unstable-nested-components */
import { ArrowRight } from 'phosphor-react';
import React, { useEffect } from 'react';
import { Box, Button } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import { DataGrid } from '../../../components/datagrid';
import { SearchFilter } from '../../../components/inputs/filters/search';
// import { SwitchInput } from '../../../components/inputs/table/SwitchInput';
import { PageTitle } from '../../../components/PageTitle';
import { useFetch } from '../../../hooks/useFetch';
import { getArrayItems, getCellStatus } from '../../../utils/FormatFunctions';
import Loader from '../../../components/Loader';
import { useAuth } from '../../../providers/auth';
// import { onToggleSwitch } from '../../../utils/onToggleFunctions';

export function InstitutionTeamsPage() {
  const { institutionId } = useParams();
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/teams?institution_id=${institutionId}`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const {
    requestApi: reqApiInstitution,
    data: dataInstitution,
    loading: loadingInstitution,
    error: errorInstitution,
  } = useFetch('/v1/admin/institutions');
  const navigate = useNavigate();
  const { user } = useAuth();
  const groupIds = user?.group?.id;
  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Nome' },
    { name: 'school_class.name', label: 'Módulo' },
    { name: 'teachers', label: 'Professores' },
    { name: 'status', label: 'Status' },
    { name: 'students', label: 'Alunos' },
  ];
  useEffect(() => {
    reqApiInstitution('get', null, `/v1/admin/institutions/${institutionId}`);
  }, [institutionId]);

  if (loadingInstitution) {
    return <Loader />;
  }

  if (errorInstitution) {
    return (
      <ErrorState
        onRetry={() => reqApiInstitution('get', null, `/v1/admin/institutions/${institutionId}`)}
      />
    );
  }

  return (
    <Box>
      <PageTitle
        description="Turmas cadastradas nesta instituição."
        backTo="/institutions/list"
        backLabel="Instituições"
        currentLabel={dataInstitution?.data?.name ?? 'Turmas'}
      >
        {dataInstitution?.data?.name ?? 'Turmas'}
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        rowActions={{ show: groupIds === 3, edit: true, delete: groupIds !== 3 }}
        columnWithAction={[
          {
            name: 'students',
            columnAction: (rowItem: any) => (
              <Button
                size="xs"
                variant="outline"
                rightIcon={<ArrowRight size={14} />}
                onClick={() => navigate(`${rowItem.id}/students`)}
              >
                Ver alunos
              </Button>
            ),
          },
          //   {
          //     name: 'status',
          //     columnAction: rowItem => (
          //       <SwitchInput
          //         values={rowItem}
          //         value={rowItem.status}
          //         changeStatus={(checked, values) =>
          //           onToggleSwitch({
          //             requestToggle,
          //             method: 'patch',
          //             checked,
          //             name: 'user',
          //             path: `${baseApiUrl}/globals/status/${values.id}`,
          //             variable: 'status',
          //           })
          //         }
          //       />
          //     ),
          //   },
        ]}
        formatColum={[
          {
            field: 'rating_topics',
            formatField: getArrayItems,
          },
          {
            field: 'teachers',
            formatField: (value) =>
              value && value.length > 0
                ? value.map((teacher: any) => teacher?.name).join(', ')
                : 'Não informado',
          },
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
